import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, Pipe, SimpleChanges } from '@angular/core';
import { AvatarProfileComponent } from "../../utilities/avatar-profile/avatar-profile.component";
import { SearchItemComponent } from "../../utilities/search-item/search-item.component";
import { FilterComponent } from "../../utilities/filter/filter.component";

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule, AvatarProfileComponent, SearchItemComponent, FilterComponent],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  showLimits = false;
  currentLimit = 20;
  indexId: string | number = '';
  @Input() filterData: any[] = [];
  @Input() tableHeader: any[] = [];
  @Input() tableData: any[] = [];
  @Input() tableTitle!: string;
  @Input() hasModalFunction!: boolean;
  @Input() loading!: boolean;
  @Input() toolbar = {
    paginate: true,
    search: true,
    filter: true,
    addnew: true,
  };

  @Output() clickToOpenModal: EventEmitter<any> = new EventEmitter<
    string | number
  >();
  @Pipe({ name: 'safeHtml' })
  @Output()
  rowClick: EventEmitter<any> = new EventEmitter<string | number>();
  @Input() emptyState: any = {
    title: '',
    label: '',
    btnText: '',
  };

  @Input() addNewDataText = '';
  @Input() rowLoader = '';
  @Input() paginationData = {
    limit: 20,
    totalData: 20,
  };
  @Input() tableWidth = ' min-w-[992px]';
  @Input() useRowLoader = false;
  @Output() addNewData: EventEmitter<any> = new EventEmitter();
  @Output() handleSearch: EventEmitter<any> = new EventEmitter<string>();
  @Output() handleFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeLimit: EventEmitter<any> = new EventEmitter<any>();

  searchAccount = (search: string) => {
    this.handleSearch.emit(search);
  };
  applyFilter = (data: any) => {
    this.handleFilter.emit(data);
  };

  viewRow = (id: string | number) => {
    this.indexId = id;
    // console.log(this.indexId);
    this.rowClick.emit(id);
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData']) {
      this.tableData = changes['tableData']?.currentValue;
      // console.log('this.tableData', this.tableData);
      // console.log('this.tableHeader', this.tableHeader);
    }
    if (changes['paginationData']) {
      this.paginationData = changes['paginationData']?.currentValue;
      this.currentLimit = this.paginationData.limit;
    }
    if (changes['loading']) {
      this.loading = changes['loading'].currentValue;
      // console.log(this.loading);
    }
    if (changes['useRowLoader']) {
      this.useRowLoader = changes['useRowLoader'].currentValue;
    }
  }
  openModal = (id: string | number) => {
    // console.log(id);
    this.clickToOpenModal.emit(id);
  };

  getSlicedData = (data: any[]) => {
    if (this.hasModalFunction) {
      return data?.slice(0, data?.length - 1);
    } else return data;
  };
  addData = () => {
    if (this.addNewDataText === 'Configure') this.clickToOpenModal.emit();
    else this.addNewData.emit();
  };

  toggleLimit = () => {
    this.showLimits = !this.showLimits;
  };
  selectLimit = (limit: number) => {
    this.currentLimit = limit;
    if (this.changeLimit) this.changeLimit.emit(limit);
  };
}
